<template>
    <span id="dashboard">
        <h2 class="mo">단비 내린 챗봇 <br>{{totalChatbotCount}}개!!!</h2>
        <h2 class="pc">단비 내린 챗봇 {{totalChatbotCount}} 개!!!</h2>
    </span>
</template>

<script>
export default {
    name: 'dashboard',
    data() {
        return {
            totalChatbotCount: 0
        };
    },
    created: function() {
        this.fetchEventsList();
        //this.timer = setInterval(this.fetchEventsList, 60000);
    },
    methods: {
        numberWithCommas: function(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        fetchEventsList: function() {

            axios.defaults.headers.post['Content-Type'] = 'application/json';
            axios.get('/chatbot/landing/count')
                .then((response) => {
                var result = response;
                //console.log(result);

                var chatbots_total = result.data.chatbots_total;
                //var day_transaction = result.data.day_transaction;
                //var total_transaction = result.data.total_transaction;

                this.totalChatbotCount = this.numberWithCommas(chatbots_total);
                //this.dayTransactionCount = this.numberWithCommas(day_transaction);
                //this.totalTransactionCount = this.numberWithCommas(total_transaction);

                /*
                if(this.totalChatbotCount != chatbots_total){

                    var change = (chatbots_total - this.totalChatbotCount) / 4;
                    change = change >= 0 ? Math.ceil(change) : Math.floor(change);

                    this.totalChatbotCount = this.totalChatbotCount + change;
                    setTimeout(this.totalChatbotCount,50);
                }

                if(this.dayTransactionCount != day_transaction){

                    var change = (day_transaction - this.dayTransactionCount) / 7;
                    change = change >= 0 ? Math.ceil(change) : Math.floor(change);

                    this.dayTransactionCount = this.dayTransactionCount + change;
                    setTimeout(this.dayTransactionCount,50);
                }

                if(this.totalTransactionCount != total_transaction){

                    var change = (total_transaction - this.totalTransactionCount) / 9;
                    change = change >= 0 ? Math.ceil(change) : Math.floor(change);

                    this.totalTransactionCount = this.totalTransactionCount + change;
                    setTimeout(this.totalTransactionCount,50);
                }

                this.interval = setInterval(()=>{

                    if(this.totalChatbotCount != chatbots_total){

                        var change = (chatbots_total - this.totalChatbotCount) / 4;
                        change = change >= 0 ? Math.ceil(change) : Math.floor(change);

                        this.totalChatbotCount = this.totalChatbotCount + change;

                    }

                }, 50);

                this.interval = setInterval(()=>{

                    if(this.dayTransactionCount != day_transaction){

                        var change = (day_transaction - this.dayTransactionCount) / 7;
                        change = change >= 0 ? Math.ceil(change) : Math.floor(change);

                        this.dayTransactionCount = this.dayTransactionCount + change;

                    }

                }, 50);

                this.interval = setInterval(()=>{

                    if(this.totalTransactionCount != total_transaction){

                        var change = (total_transaction - this.totalTransactionCount) / 9;
                        change = change >= 0 ? Math.ceil(change) : Math.floor(change);

                        this.totalTransactionCount = this.totalTransactionCount + change;

                    }

                }, 50);
                */
            })
            .catch((error) => {
                console.log(error);
            });
        },
        cancelAutoUpdate: function() {
            //clearInterval(this.timer)
        }
    },
    beforeDestroy() {
        //clearInterval(this.timer)
    },
    computed: {
        getsentenceOutput: function() {
            return this.sentenceOutput;
        }
    }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/landingdashboard.vue?3bde4454